(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["argile-chat"]) return;
  try {
    
  (function () {
    function setup(root) {
      if (!root || root.dataset.patReady) return;
      root.dataset.patReady = '1';

      var fab = root.querySelector('[data-pat-chat-toggle]');
      var panel = root.querySelector('[data-pat-chat-panel]');
      var closeBtn = root.querySelector('[data-pat-chat-close]');
      var log = root.querySelector('[data-pat-chat-log]');
      var chips = root.querySelectorAll('[data-pat-chat-key]');
      var answers = root.querySelector('[data-pat-chat-answers]');
      if (!fab || !panel || !log || !answers) return;

      function open() {
        panel.hidden = false;
        root.setAttribute('data-open', '');
        fab.setAttribute('aria-expanded', 'true');
        var first = root.querySelector('.pat-chat__chip');
        if (first) first.focus();
      }

      function close() {
        panel.hidden = true;
        root.removeAttribute('data-open');
        fab.setAttribute('aria-expanded', 'false');
        fab.focus();
      }

      fab.addEventListener('click', function () {
        if (panel.hidden) open(); else close();
      });

      if (closeBtn) closeBtn.addEventListener('click', close);

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !panel.hidden) close();
      });

      function push(html, who) {
        var bubble = document.createElement('div');
        bubble.className = 'pat-chat__bubble pat-chat__bubble--' + who;
        bubble.innerHTML = html;
        log.appendChild(bubble);
        log.scrollTop = log.scrollHeight;
        return bubble;
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var key = chip.getAttribute('data-pat-chat-key');
          var source = answers.content
            ? answers.content.querySelector('[data-answer-for="' + key + '"]')
            : answers.querySelector('[data-answer-for="' + key + '"]');
          if (!source) return;

          push(chip.textContent.trim(), 'user');

          var typing = push('<span class="pat-chat__typing"><span></span><span></span><span></span></span>', 'bot');
          window.setTimeout(function () {
            typing.innerHTML = source.innerHTML;
            log.scrollTop = log.scrollHeight;
          }, 520);
        });
      });
    }

    function boot() {
      document.querySelectorAll('[data-argile-chat]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
